import { render, staticRenderFns } from "./FavoriteAction.vue?vue&type=template&id=a8b25ce6&scoped=true"
import script from "./FavoriteAction.vue?vue&type=script&lang=js"
export * from "./FavoriteAction.vue?vue&type=script&lang=js"
import style0 from "./FavoriteAction.vue?vue&type=style&index=0&id=a8b25ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b25ce6",
  null
  
)

export default component.exports